var map = {
	"./ABNAMRO.svg": "9cef",
	"./ASN.svg": "b641",
	"./BUNQ.svg": "fcb6",
	"./Binck.svg": "19af",
	"./HAND.svg": "06d1",
	"./ING.svg": "5bbb",
	"./KNAB.svg": "9103",
	"./MOYO.svg": "2eff",
	"./RABO.svg": "f468",
	"./REGIOBANK.svg": "7dc4",
	"./REVOLUT.svg": "17c3",
	"./SNS.svg": "2a35",
	"./Sofort.svg": "dfca",
	"./TRIODOS.svg": "2506",
	"./VANLANSCHOT.svg": "feda",
	"./YOURSAFE.svg": "8082"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "c4db";